import { render, staticRenderFns } from "./AddUpdateSupplier.vue?vue&type=template&id=33b0a50e&"
import script from "./AddUpdateSupplier.vue?vue&type=script&lang=js&"
export * from "./AddUpdateSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports